export default "__VITE_ASSET__b6672868__"